var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contributions columns is-multiline  mx-2" },
    [
      _c("settings-sidebar", {
        staticClass: "column is-3 py-2 mr-md-3 mb-3 mb-md-auto",
        attrs: { "active-menu-item": "contributions" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column card p-3 px-2 px-md-6 mb-3" },
        [
          _c("h1", { staticClass: "h2 t-orange mb-3" }, [
            _vm._v("Your Contributions")
          ]),
          _vm._v(" "),
          _vm.contributions
            ? _c(
                "ul",
                { staticClass: "contributors rows" },
                _vm._l(_vm.contributions.data, function(contribution) {
                  return _c(
                    "li",
                    {
                      staticClass: "contributor row px-3 py-12px t-navy w-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "column p-0 contributor__name py-12px" },
                        [_vm._v(_vm._s(contribution.hazard.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column p-0 contributor__total font-weight-light"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formattedDate(contribution.created_at)
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column p-0 contributor__btn text-sm-right"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-ghost bg-white",
                              attrs: { href: contribution.hazard.url }
                            },
                            [_vm._v("View")]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contributions.last_page > 1
            ? [
                _c("paginate", {
                  attrs: {
                    "page-count": _vm.contributions.last_page,
                    "prev-text": "&nbsp;",
                    "next-text": "&nbsp;",
                    "prev-link-class": "pagination-previous",
                    "next-link-class": "pagination-next",
                    "container-class": "pagination-list",
                    "page-class": "pagination-item",
                    "page-link-class": "pagination-link",
                    "click-handler": _vm.paginate
                  }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b728b666", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b728b666","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Contributions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b728b666","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Contributions.vue
// module chunks = 0 1